import { render, staticRenderFns } from "./disputes-dialog-candidate-reasons-card.vue?vue&type=template&id=62a9371c"
import script from "./disputes-dialog-candidate-reasons-card.vue?vue&type=script&lang=js"
export * from "./disputes-dialog-candidate-reasons-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports